<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-7 col-sm-12 col-xs-12">
                        <h4 class="card-title">{{ 'invoices' | localise }}</h4>
                    </div>
                    <div class="col-md-5 col-sm-12 col-xs-12 text-right">
                        <button
                                *ngIf="!(currentSubscription && currentSubscription.pricing_plan.id != getFreePricingPlanId())"
                                type="button"
                                class="buy-subscription btn btn-primary btn-icon-text"
                                routerLink="/pricing">
                            <i class="ti-credit-card btn-icon-prepend"></i>
                            {{ 'buy_subscription' | localise }}
                        </button>
                    </div>
                </div>

                <div class="row" style="padding-top: 15px;">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table datatable class="table">
                                <thead>
                                <tr class="bg-primary text-white">
                                    <th>{{ 'plan' | localise }}</th>
                                    <th>{{ 'date' | localise }}</th>
                                    <th>{{ 'price_amount' | localise }}</th>
                                    <th>{{ 'status' | localise }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let invoice of invoices">
                                    <td style="text-transform: uppercase;">{{ invoice?.subscription?.pricing_plan.title }}</td>
                                    <td>
                                        {{ invoice?.created_at | date: constants.defaultDateTimeFormat }}
                                    </td>
                                    <td>{{ invoice?.amount | money }}</td>
                                    <td [ngSwitch]="invoice?.status">
                                        <label *ngSwitchCase="paymentStatuses.CANCELLED"
                                               class="badge badge-danger">{{ 'invoice_status_cancelled' | localise }}</label>
                                        <label *ngSwitchCase="paymentStatuses.PAID"
                                               class="badge badge-success">{{ 'invoice_status_paid' | localise }}</label>
                                        <label *ngSwitchCase="paymentStatuses.PENDING"
                                               class="badge badge-warning">{{ 'invoice_status_pending' | localise }}</label>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section
        *ngIf="currentSubscription && currentSubscription.pricing_plan.id != getFreePricingPlanId() && currentSubscription.to_date == null"
        class="content"
        style="margin-top: 20px;">
    <app-alerts-components
            [type]="'warning'"
            [disableClose]="true"
            [icon]="'fa fa-exclamation-triangle'"
            [id]="'cancel_user_subscription'"
            [title]="'cancel_user_subscription_title' | localise"
            [message]="'cancel_user_subscription_text' | localise"></app-alerts-components>

    <button (click)="cancelUserSubscription()" class="btn btn-primary btn-sm">
        {{ 'cancel_user_subscription_btn' | localise }}
    </button>
</section>

<section
        *ngIf="currentSubscription && currentSubscription.pricing_plan.id != getFreePricingPlanId() && currentSubscription.to_date != null"
        class="content"
        style="margin-top: 20px;">
    <app-alerts-components
            [type]="'warning'"
            [disableClose]="true"
            [icon]="'fa fa-exclamation-triangle'"
            [id]="'cancel_user_subscription'"
            [title]="'cancel_user_subscription_title' | localise"
            [message]="'Вашият план е прекратен, а текущото му изпозлване е заплатено до ' + formatDate(currentSubscription.to_date)"></app-alerts-components>
</section>

